import { motion, useTransform, useScroll } from 'framer-motion';
import { useRef } from 'react';

const HorizontalScroll = () => {
  const targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const x = useTransform(scrollYProgress, [0, 1], ['-90vw', '20vw']);
  return (
    <div ref={targetRef} className='hscroll'>
      <motion.div className='hscroll_container' style={{ x }}>
        <div className='hscroll_container_card'>
          <b>168</b> STANOVA
        </div>
        <div className='hscroll_container_card'>
          <b>151</b> GARAŽNIH MJESTA
        </div>
        <div className='hscroll_container_card'>
          <b>6</b> POSLOVNIH PROSTORA
        </div>
        <div className='hscroll_container_card'>
          <b>36</b> VANJSKIH PARKIRINH MJESTA
        </div>
      </motion.div>
    </div>
  );
};

export default HorizontalScroll;
